import React from 'react';
import PropTypes from 'prop-types';
// import '../../../App.css';
import Background from '../../../assets/img/new-logo-4-bg.png';
import { fetchContracts, getDeletable, updatePrintContract, sendSignLinkViaEmail, getContractShippers, updateContractShipper } from './../../../actions/contracts';
import { fetchConfig } from "../../../actions/configuration";
import { getCurrentUser } from './../../../actions/user';
import { fetchAnimalTypes } from '../../../actions/addAnimalType';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import history from "../../../history.js";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { NavLink } from 'react-router-dom';
import { Loader } from '../../../components/loader';
import { BreadCrumb } from '../../../components/breadcrumb';
import { formatPhoneNumber } from  '../../../utils/helper';
import ContractPDF from '../../../components/contractPdf/contractPdf.js';
import moment from 'moment';
import { Activity } from '../../../components/activity';
import Select from "react-select";
const $ = window.$;
var toaOptions = {};

const { SearchBar } = Search;

const toCapitalize = (name) => {
  if (name && name.length > 1) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
}
class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    confirmDelete: false,
    contentData: [],
    selected: [],
    loadingDelete: false,
    deleteId: null,
    user_role:'',
    clickedId: '',
    pdfOldVersion: false,
    loadingContracts: true,
    loadingAssignShipper : false,
  };

  tableHeaderColumnData = [
    {
      dataField: 'actions', text: 'Actions', formatter: this.buttonFormatter.bind(this),style:{'overflowX':'visible'}
    },
    {
      dataField: 'cus_firstname', text: 'Customer', sort: true,  formatter:(cell,row)=>{
        return (
          <p>
            {row.cus_firstname +' '+ row.cus_lastname}
          </p>
        )
      },
    },
    {
      dataField: 'pet_id', text: 'State / City', sort: true, formatter: (cell, row) => {
        return (    
         <> 
          <span> <strong>{row.cus_state}</strong></span><br/> 
          <span> {row.cus_city} </span><br/>       
         </>
        )      
      }
    },
    {
      dataField: 'date', type: 'date', text: 'Date of Contract', formatter: cell => moment(cell).format('MM-DD-YYYY'), sort: true, 
    },
    {
      dataField: 'breed_type', text: 'Breed', sort: true
    },
    {
      dataField: 'gender', text: 'Gender', sort: true
    },
    {
      dataField: 'cus_primary', 
      text: 'Primary / Secondary Phone', 
      sort: true,
      formatter: (cell, row) => {
        return (    
         <> 
          <span><a href={`tel:${row.Customer.phone_primary}`} className="hyperlink-phone-number">{row.Customer.phone_primary}</a></span><br/> 
          <span> <a href={`tel:${row.Customer.phone_secondary}`} className="hyperlink-phone-number">{row.Customer.phone_secondary}</a></span><br/>       
         </>
        )      
      }
    },
    {
      dataField: 'shipper_name', text: 'Transporter', sort: true, 
      formatter: (cell, row) => {
        return (            
          <div>
          { cell ?
          <a
            href='#'
            onClick={(e)=>{ this.openShipperAssignConfirmationModal(e,row,) }}
          >

            <div className="m-widget4__ext">
              <i className="la la-edit text-dark"></i>
               <div className="text-sm text-dark"><strong>{cell}</strong></div>
            </div> 

          </a>:
          <a
           href='#'
           onClick={(e)=>{ this.openShipperAssignConfirmationModal(e,row,) }}
          >
            <div className="m-widget4__ext">
            <i className="la la-edit"></i>
              <div className="text-sm"><strong>Not assigned</strong></div>
            </div> 

          </a>        
              
           }
        
          </div>  
         
        )}    
    },    
    {
      dataField: 'woo_coupon_code', 
      text: 'Coupon', 
      sort: true,
      formatter: cell => <span>{ cell }</span>
    },
    {
      dataField: 'cus_email', 
      text: 'Email', 
      sort: true,
      formatter: (cell, row) => <a href={`mailto:${cell}?body=Hello, ${toCapitalize(row.cus_firstname)}!`} className="hyperlink">{cell}</a>
    },
    {
      dataField: 'cus_find_us', text: 'How did you find us', sort: true
    },
    {
      dataField: 'pet_id', text: 'UTM Source / ID / Campaign / Medium', sort: true, formatter: (cell, row) => {
        return (
        (  row.utmData && row.utmData.id ?  
         <>       
          <span className="m-badge my-0 px-2 m-badge--warning">               
          <strong>{row.utmData.utm_source} </strong>           
          </span><br/>
          <span className="m-badge mt-1 px-2 m-badge--success"> {row.utmData.utm_id} </span><br/>
          <span className="m-badge mt-1 px-2 m-badge--primary"> {row.utmData.utm_campaign} </span><br/>
          <span className="m-badge mt-1 px-2 m-badge--accent"> {row.utmData.utm_medium} </span>
         </>:
         <span>No Utm <br/> Source</span>
        )      
      
        
        )
      }
    },
    // {
    //   dataField: 'pet_type', text: 'Pet', sort: true, formatter: cell => cell,
    //   filter: selectFilter({
    //     options: toaOptions
    //   }),      
    //   filterValue: (cell, row) => {
    //     for(let t in toaOptions){
    //       if(toaOptions[t]===cell){
    //         return t;
    //       }
    //     }
    //   }
    // },
        {
      dataField: 'pet_id', text: 'Pet ID / Medical Record', sort: true, formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img src={process.env.REACT_APP_S3_PATH + '/' + row.avatar_path + '/' + row.avatar_file_name} className="m--img-rounded m-width-50 mr-2" alt="" />
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
            <strong>
              <a
                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id }/${row.MedicalRecord.id}`}
                target="_blank"  
                style={{ color:"#ffff"}}      
               >
               {cell}
              </a>
            </strong>
            </span> 
          </span>
        )
      }
    },
    {
      dataField: 'sub_total', text: 'Subtotal($)', sort: true
    },     
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity  row={row} created={row.createdContract} updated={row.updatedContract} deleted={row.deletedContract}/>
        );
      },
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    }
    
  ];

  buttonFormatter(cell, row) {
    return (
      <div>
      { this.state.pdfOldVersion == true ?
        <span className="dropdown show">
          <span className="dropdown">  
           <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="far fa-eye"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">  
              <a
                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/contract/pdf/${this.props.data.petShopReducer.currentPetshop.id }/${row.id}`}
                className="dropdown-item"
                target="_blank"        
               >
                <i className="fa fa-print"></i>Print
              </a>              
              <a
                href="#"
                className="dropdown-item"                
                onClick={() => {
                  this.openPdf(row.id)
                }}
              >
                <i className="fa fa-print"></i>Print (Old) 
              </a>
                
            
            </div>
          </span>
        </span>:
         <button className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" title="View">
          <a
           href={ `${process.env.REACT_APP_API_ENDPOINT}/core/contract/pdf/${this.props.data.petShopReducer.currentPetshop.id }/${row.id}`}
           target="_blank"   
          >
            <i className="far fa-eye"></i>
          </a>          
        </button>
        }

        {/* <button onClick={() => this.openPdf(row.id)} className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" title="View">
          <i className="far fa-eye"></i>
        </button> */}
        <span className="dropdown show">
            <span className="dropdown">
              <a href="" className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
                <i className="la la-ellipsis-h"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                <NavLink to={`/contracts/${row.id}`} className="dropdown-item" title="View">
                  <i className="la la-edit"></i> Edit 
                </NavLink>
                <a className="dropdown-item" onClick={() => (row.Contract) ? this.openRejectModal() : this.openConfirmModal(row.id) }>
                  <i className="la la-trash-o"></i> Delete 
                </a>
                <a
                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/contract/doc/pdf/generate7006/${this.props.data.petShopReducer.currentPetshop.id }/${row.id}`}
                className="dropdown-item"
                target="_blank"        
               >
                <i className="fa fa-print"></i>Form 7006
              </a>
              </div>
            </span>
        </span>
      </div>
    );
  }

  openPdf = (id) => {
    if(this.state.clickedId !== id) {
      this.setState({clickedId: id});
    }
    else {
      if(this.props.data.contractsReducer.printContract)
        this.childDownload();
    }
  }

  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }

  openRejectModal() {
    $('#reject_modal').modal('show');
  }

  openConfirmModal(mrId) {
    this.setState({deleteId: mrId})
    $('#confirm_delete_modal').modal('show');
  }
  componentDidMount() { 
    this.props.fetchContracts();
    this.props.fetchAnimalTypes();
    $( ".react-bootstrap-table-pagination" ).css( "display","none" ); 
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.toa && this.props.toa !== nextProps.toa) {
      let i = 0;
      for(let t of nextProps.toa){
        toaOptions[i] = t.type;
        i++;
      }  
    }
    if(nextProps.data.userReducer.currentUser){
     
      const user_role= nextProps.data.userReducer.currentUser.UserPetstores[0].Role.role_name;
      if(user_role === 'Admin'){
        $( ".react-bootstrap-table-pagination" ).css( "display","flex" );    
      }
      
    }

    if (nextProps.data.contractsReducer.contract !== this.props.data.contractsReducer.contract) {
      this.props.fetchContracts();
    }
    if (nextProps.data.contractsReducer.contracts &&
       nextProps.data.contractsReducer.contracts.contractRecords && 
      nextProps.data.contractsReducer.contracts.contractRecords.length >0 && 
      nextProps.data.contractsReducer.contracts !== this.props.data.contractsReducer.contracts
      ) {
      let records = nextProps.data.contractsReducer.contracts.contractRecords;
      let configPdfVersion = nextProps.data.contractsReducer.contracts.configPdfVersion;    
      records.sort((a, b) => (a.id > b.id ? -1 : 1));
      let phoneNumberFormatArray = records.map( (item)=>{     
        item.cus_primary = item.cus_primary ? formatPhoneNumber(item.cus_primary): null;
        item.cus_secondary = item.cus_secondary ? formatPhoneNumber(item.cus_secondary):null;   
        return item;
      }); 

      this.setState({ contentData: phoneNumberFormatArray, pdfOldVersion: configPdfVersion, loadingContracts : false });
    }
    if (nextProps.data.contractsReducer.contracts &&
      nextProps.data.contractsReducer.contracts.contractRecords && 
     nextProps.data.contractsReducer.contracts.contractRecords.length <= 0 && 
     nextProps.data.contractsReducer.contracts !== this.props.data.contractsReducer.contracts
     ) {  
     NotificationManager.warning('Contracts not found.');
     this.setState({ loadingContracts : false });
   }
    if (nextProps.data.contractsReducer.contractsError !== this.props.data.contractsReducer.contractsError) {
      NotificationManager.error('Failed to load contracts.');
    }
    if (nextProps.data.contractsReducer.selectedToDeleteError !== this.props.data.contractsReducer.selectedToDeleteError) {
      this.setState({loadingDelete: false});
      NotificationManager.error('Failed to delete contract.');
      $('#confirm_delete_modal').modal('hide');
    }
    if (nextProps.data.contractsReducer.selectedToDelete !== this.props.data.contractsReducer.selectedToDelete && nextProps.data.contractsReducer.selectedToDelete > 0) {
      this.setState({loadingDelete: false});
      this.props.fetchContracts();
      NotificationManager.success("Contract Deleted Successfully");
      $('#confirm_delete_modal').modal('hide');
    }
    if (nextProps.data.contractsReducer.contractShippers !== this.props.data.contractsReducer.contractShippers && nextProps.data.contractsReducer.contractShippers) {
     let shippers = nextProps.data.contractsReducer.contractShippers
     let options = [];
      shippers.map(p => {
        options.push({ label: p.company_name, value: p.id, data : p });
      });
      this.setState({ shippersArray :  options});    
    }
    if (nextProps.data.contractsReducer.contractShippersError !== this.props.data.contractsReducer.contractShippersError && nextProps.data.contractsReducer.contractShippersError) {
      NotificationManager.error("An error occured while loading the shippers")
 
     }
      
    if (nextProps.data.contractsReducer.contractUpdatedShippers !== this.props.data.contractsReducer.contractUpdatedShippers && nextProps.data.contractsReducer.contractUpdatedShippers) {
       this.props.fetchContracts();
       this.setState({ loadingAssignShipper : false });
       NotificationManager.success("Shipper assigned successfully");
       $("#assign_shipper_modal").modal("hide");
    }
    if (nextProps.contractUpdatedShippersError !== this.props.contractUpdatedShippersError && nextProps.contractUpdatedShippersError) {
      this.setState({ loadingAssignShipper : false });           
      if( nextProps.contractUpdatedShippersError && nextProps.contractUpdatedShippersError.details && nextProps.contractUpdatedShippersError.details.message){
        NotificationManager.warning(nextProps.contractUpdatedShippersError.details.message);
      }else{
        NotificationManager.error("An error occured while assigning the shipper");
      }                     
      $("#assign_shipper_modal").modal("hide");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.clickedId && this.state.clickedId !== prevState.clickedId) {
      this.props.updatePrintContract(this.state.clickedId);
    }
    if(this.props.data.contractsReducer.printContract && prevProps.data.contractsReducer.printContract !== this.props.data.contractsReducer.printContract){
      this.childDownload();
    }
  }


  handleClose = (value) => {
    this.props.reset('newContractForm');
    this.props.fetchContracts();
  };

  handleDeleteConfirm = () => {
    this.props.getDeletable(this.state.selected);
    this.handleClose();
  }

  handleDelete = (selected) => {
    if (!(selected === null || selected === undefined) && selected !== 0) {
      this.setState({ confirmDelete: true, selected });
    }
  }
  
  deleteContract(){
    this.setState({ loadingDelete: true });
    
    if(this.state.deleteId)
        this.props.deleteContracts(this.state.deleteId);
    else {
        NotificationManager.warning('Invalid contract.');
        this.setState({ loadingDelete: false });
    }
  }

  handleChildUnmount(){
    this.setState({clickedId: false});
  }
  openShipperAssignConfirmationModal(e,row){
    e.preventDefault();
    this.setState({ selectedContractId : row.id });
    this.resetState();
    this.props.getContractShippers();
     $("#assign_shipper_modal").modal("show");   
  }
  sendSignatureLinkViaEmail(){
    let sendingDataObj = this.state.sendingDataEmail;
    this.setState({ loadingSignature : true });
    this.props.sendSignLinkViaEmail(sendingDataObj);
  }
  assignShipperToContract(){
    if(this.state.shipperId){
     this.setState({ loadingAssignShipper : true });
     this.props.updateContractShipper(this.state.selectedContractId,{ shipperId : this.state.shipperId});
    }else{
      NotificationManager.warning("Please select the shipper first")
    }
  }
  changeShipper = selected => {
    if (selected) { 
      this.setState({ shipperId: selected.value,
        shipperCompanyName:  selected.data.company_name,
        shipperAddressLine1: selected.data.address_line1,
        shipperAddressLine2: selected.data.address_line2,
        shipperAddressCity: selected.data.address_city,
        shipperAddressState: selected.data.address_state,      
      });
    }
  };
  resetState(){
    this.setState({
      shipperId: "",
      shipperCompanyName: "",      
      shipperAddressLine1: "",
      shipperAddressLine2: "",                                       
      shipperAddressCity: "",
      shipperAddressState: "", 
      address_zipcode: "",
    })
  }

  items = [
    {title: 'Contracts', to: '/contracts'}
  ]

  render() {
    const { classes, theme } = this.props;
    const { contentData, loadingContracts, shippersArray, shipperId  } = this.state;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items}/>
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              
              <div className="m-portlet m-portlet--mobile">
                
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Contracts
                      </h3>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">
                    <NavLink to={`/contracts/add`} className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill">
                      <span>
                        <i className="la la-plus"></i>
                        <span>
                          New Contract
                        </span>
                      </span>
                    </NavLink>
								  </div>
                </div>
                <div className="m-portlet__body">
                { !loadingContracts ?
                <ToolkitProvider
                      
                      keyField="id"
                      data={contentData}                      
                      columns={this.tableHeaderColumnData}
                      search
                      defaultSortDirection="asc" 
                      hover={true} 
                      filter={ filterFactory() } 
                    >
                      {
                        props => (
                          <div>
                            <div className='px-0 mb-4 search-bar'>
                              <div className='col-lg-3 px-0 inner-addon right-addon'>
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                              </div>
                            </div>
                            <div className="mb-2"><small className="small-text">*If you experience any difficulty in viewing the contract, please make sure your cache is cleared and completed a hard refresh. IOS users might have to use a private window.</small></div>
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={ paginationFactory() } 
                            />
                          </div>
                        )
                      }
                </ToolkitProvider>:
                <div className="center-row">
                  <Loader size={50} />
                </div>
                }
                  
                </div>
                
              </div>
              <div className="modal fade" id="confirm_delete_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm to delete</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this contract?</p>
                        </div>
                        <div className="modal-footer">
                        {this.state.loadingDelete == false ?
                            <div>
                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                                <button type="button" onClick={() => this.deleteContract()} className="btn btn-primary m-btn--pill">Confirm</button>
                            </div>
                            :
                            <div className="center-row">
                                <Loader size={50} />
                            </div>
                        }
                        </div>
                    </div>
                </div>
              </div>          
              {/* Start asign shipper modal */}
              <div className="modal fade" id="assign_shipper_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Assign Shipper to Contract</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {/* <p>Are you sure you want to send sign link via email?</p> */}
                            <div className="row m-form">
                                    <div className="col-12">
                                        <div className="form-group m-form__group row">
                                            <label className="col-2 col-form-label">Shipper:</label>
                                            <div className="col-10">
                                                <Select options={shippersArray}  name="ShipperId" value={shipperId} onChange={this.changeShipper} placeholder="Select the shipper" />
                                                <span>Please select a shipper</span>
                                            </div>
                                        </div> 
                                       { shipperId ?
                                        <>
                                          <div className="m-form__seperator m-form__seperator--dashed my-3"></div>
                                          <div className="form-group m-form__group row">
                                              <label className="col-2 col-form-label">Address:</label>
                                              <div className="col-10">
                                                  {this.state.shipperCompanyName}
                                                  <br/>
                                                  {this.state.shipperAddressLine1}, {this.state.shipperAddressLine2}                                             
                                                  <br/>
                                                  {this.state.shipperAddressCity}
                                                  <br/>
                                                  {this.state.shipperAddressState}, {this.state.address_zipcode}
                                              </div>
                                          </div> 
                                        </>:null
                                        }
                                    </div>
                                </div>
                        </div>
                        <div className="modal-footer">
                        {this.state.loadingAssignShipper == false ?
                            <div>
                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                                <button type="button" onClick={() => this.assignShipperToContract()} className="btn btn-primary m-btn--pill">Assign</button>
                            </div>
                            :
                            <div className="center-row">
                                <Loader size={50} />
                            </div>
                        }
                        </div>
                    </div>
                </div>
              </div>
              {/* end asign shipper modal */}
            </div>
          </div>
          
          
        </div>
        {this.state.clickedId ? <ContractPDF setClick={this.acceptMethods.bind(this)} unmountMe={this.handleChildUnmount.bind(this)} /> : null}
      </div>
    );
  }
}


const mapStateToProps = state => ({
  data: state,
  toa: state.addAnimalTypeReducer.animalTypes,
  toaError:state.addAnimalTypeReducer.animalTypesError,
  contractsError:state.contractsReducer.contractsError,
  contractUpdatedShippersError: state.contractsReducer.contractUpdatedShippersError,
  
});

const mapDispatchToProps = dispatch => ({
  fetchAnimalTypes: () => {
    dispatch(fetchAnimalTypes());
  },
  fetchContracts: () => {
    dispatch(fetchContracts());
  },
  deleteContracts: (selected) => {
    dispatch(getDeletable(selected));
  },  
  updatePrintContract: (id) => {
    dispatch(updatePrintContract(id));
  },
  fetchConfig: () => {
    dispatch(fetchConfig());
  },
  getContractShippers: () => {
    dispatch(getContractShippers());
  },
  updateContractShipper: (id,data) => {
    dispatch(updateContractShipper(id,data))
  }
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);
